// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Account Attestation Attribute Save Model V2
*/
export class AccountAttestationAttributeSaveModelV2 {
    /**
    * @description Attestation Attribute ID
    */
    'attestationAttributeId'?: number;
    /**
    * @description If null is passed in as end date,  this field to determine what the null mean
    */
    'nullEndDateToCalculate'?: boolean;
    'needPublishMessage'?: boolean;
    /**
    * @description Attestation Value
    */
    'value'?: string | null;
    /**
    * @description Attestation Start Date
    */
    'attestationStartDate'?: Moment | null;
    /**
    * @description Attestation End Date
    */
    'attestationEndDate'?: Moment | null;
    /**
    * @description Document ID
    */
    'documentId'?: number | null;
    /**
    * @description Attestation source code
    */
    'attestationSourceCode'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof AccountAttestationAttributeSaveModelV2>> = [
        {
            "name":     "attestationAttributeId",
            "baseName": "attestationAttributeId",
            "type":     "number"
        },
        {
            "name":     "nullEndDateToCalculate",
            "baseName": "nullEndDateToCalculate",
            "type":     "boolean"
        },
        {
            "name":     "needPublishMessage",
            "baseName": "needPublishMessage",
            "type":     "boolean"
        },
        {
            "name":     "value",
            "baseName": "value",
            "type":     "string"
        },
        {
            "name":     "attestationStartDate",
            "baseName": "attestationStartDate",
            "type":     "Date"
        },
        {
            "name":     "attestationEndDate",
            "baseName": "attestationEndDate",
            "type":     "Date"
        },
        {
            "name":     "documentId",
            "baseName": "documentId",
            "type":     "number"
        },
        {
            "name":     "attestationSourceCode",
            "baseName": "attestationSourceCode",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return AccountAttestationAttributeSaveModelV2.attributeTypeMap;
    }
}
